/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProfileNewsletterSettings } from '../../models/profile-newsletter-settings';

export interface ProfileNewsletterChangeSettings$Params {
  id: number;
      body: ProfileNewsletterSettings
}

export function profileNewsletterChangeSettings(http: HttpClient, rootUrl: string, params: ProfileNewsletterChangeSettings$Params, context?: HttpContext): Observable<StrictHttpResponse<ProfileNewsletterSettings>> {
  const rb = new RequestBuilder(rootUrl, profileNewsletterChangeSettings.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ProfileNewsletterSettings>;
    })
  );
}

profileNewsletterChangeSettings.PATH = '/rest/profile/{id}/newsletter/settings';
